export default "__VITE_ASSET__Cta9$ZD3__"